import React from 'react';
import * as utils from "../utils";


//Gjenpartsbrev
class DuplicateLetter extends React.Component {

    handleClick(document) {
        window.gtag('event', 'last ned', {
            'event_category': 'click',
            'event_label': document
        });
    }

    render() {
        var letters = this.props.loans;
        var indexType = this.props.indexType;

        if (letters.errorMessage === undefined ) {
            return <div id={'collapse' + indexType} className='panel-collapse collapse' aria-labelledby={'heading' + indexType}>
                <div>
                    <div className="d-xl-none">
                        <div key={indexType} className='card-body list padding-0'>
                            <table className="tableLoanCol">
                                <tbody>
                                {letters.map(function (letter, indexLetter) {
                                    var link = "/innsyn/gjenpartsbrev?id=" + letter.documentId;
                                    return (
                                        <React.Fragment>
                                            <tr className={utils.tableStripes(indexLetter, false)}>
                                                <th>Kredittyter</th>
                                                <td className="bold">{letter.name}</td>
                                            </tr>
                                            <tr className={utils.tableStripes(indexLetter, false)}>
                                                <th>Dato</th>
                                                <td>{letter.issued}</td>
                                            </tr>
                                            <tr className={utils.tableStripes(indexLetter, true)}>
                                                <th>Link</th>
                                                <td><a href={link} target="_blank" rel="noopener noreferrer" onClick={()=>{this.handleClick('gjenpartsbrev pdf')}}>Vis dokument</a></td>
                                            </tr>
                                        </React.Fragment>
                                    )
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="d-none d-xl-block">
                        <div key={indexType} className='card-body list padding-0'>
                            <table className="tableLoanRow">
                                <tbody>
                                <tr>
                                    <th className="headerLeft height35">Kredittyter</th>
                                    <th className="headerLeft height35">Dato</th>
                                    <th className="headerLeft height35">Link</th>
                                </tr>
                                {letters.map(function (letter, indexLetter) {
                                    var link = "/innsyn/gjenpartsbrev?id=" + letter.documentId;
                                    return (
                                        <tr>
                                            <td className="cellLeftBold height35">{letter.name}</td>
                                            <td className="cellLeft height35">{letter.issued}</td>

                                            <td className="cellLeft height35"><a href={link} target="_blank" rel="noopener noreferrer" onClick={()=>{this.handleClick('gjenpartsbrev pdf')}}>Vis dokument</a></td>
                                        </tr>
                                    )
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        }
        else {
            return <div id={'collapse' + indexType} className='panel-collapse collapse' aria-labelledby={'heading' + indexType}>
                <div>
                    <span className="updatetMarkingInfo">!&nbsp;</span><span className="accordionMessage">Gjenpartsbrev er ikke tilgjengelig for øyeblikket, prøv igjen senere</span>
                </div>
            </div>
        }
    }
}

export default DuplicateLetter;